import { Box, Button, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useAppRedirect } from 'hooks/useAppRedirect';
import { useAccount } from 'queries/accounts/useAccount';

import BorderStack from 'components/@common/BorderStack';
import GenericPageLayout from 'components/@screens/GenericPageLayout';

const stripForwardSlash = (path: string) => {
  if (path.startsWith('/')) {
    return path.substring(1);
  }

  return path;
};

const ViewInAppContainer = () => {
  const { account } = useAccount();
  const { onRedirect, openStore, isLoading } = useAppRedirect();
  const { query } = useRouter();

  const intl = useIntl();

  const handleAppRedirect = () => {
    if (query?.['url']) {
      const url = new URL(query['url'] as string)?.pathname;
      onRedirect(stripForwardSlash(url));
    } else {
      openStore();
    }
  };

  return (
    <GenericPageLayout>
      <Box
        sx={{
          mt: { xs: 5, md: 9 },
          flex: { xs: 1, md: 0 },
        }}
      >
        <BorderStack
          sx={{
            py: 3,
            gap: 2,
            mb: { xs: 3, md: 5 },
          }}
        >
          <Typography variant="h6">
            <FormattedMessage id="download_app.info.title" />
          </Typography>
          <Typography variant="body2">
            <FormattedMessage
              id="download_app.info.description"
              values={{
                b: (chunks: Array<ReactNode>) => {
                  return (
                    <Typography
                      variant="body2"
                      component="span"
                      sx={{
                        fontWeight: 'bold',
                      }}
                    >
                      {chunks}
                    </Typography>
                  );
                },
                email:
                  account?.email ??
                  intl.formatMessage({ id: 'email.fallback' }),
              }}
            />
          </Typography>
        </BorderStack>
      </Box>
      <Button
        variant="outlined"
        color="secondary"
        fullWidth
        onClick={handleAppRedirect}
        loading={isLoading}
      >
        <FormattedMessage id="tickets.checkout.confirmation.view.tickets_overview_mobile" />
      </Button>
    </GenericPageLayout>
  );
};

export default ViewInAppContainer;
